<template>
    <v-container>
        <v-layout justify-center wrap>
            <!-- TITLE -->
            <v-flex xs12>
                <w-main-title
                    class="pb-0"
                    title="Revisa tu Agenda"
                    :breadcrumbs="breadcrumbs"
                ></w-main-title>
            </v-flex>
            <!-- FILTER -->
            <v-flex xs12 sm4 md2>
                <v-select
                    label="Estado de la Cita"
                    :items="states"
                    item-text="text"
                    item-value="value"
                    v-model="state"
                    @click:clear="clear"
                    clearable
                ></v-select>
                <v-btn block outline color="primary" small @click="applyFilters" :loading="consulting">
                    Aplicar Filtro
                </v-btn>
            </v-flex>
            <!-- LOADING -->
            <v-flex xs12 sm8 md10 v-if="loading">
                <div class="text-xs-center">
                    <v-progress-circular
                        indeterminate
                        color="primary"
                        width="2"
                    ></v-progress-circular>
                </div>
            </v-flex>
            <v-flex xs12 sm8 md10 v-else>
                <v-container grid-list-md>
                    <v-layout row wrap v-if="appointments.length === 0">
                        <v-flex xs12 class="text-xs-center">
                            <h3 class="font-weight-light">No hay Citas en Agenda</h3>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6 v-for="item in appointments" :key="item.id">
                            <user-appointment
                                :reserved="item.reserved_at"
                                :confirmed="item.event_status_id >= 2"
                                :date="item.date"
                                :time="item.time"
                                :service="item.schedule.service_item ? item.schedule.service_item.service.name : `${item.schedule.specialist.first_name} ${item.schedule.specialist.last_name}`"
                                :serviceItem="item.schedule.service_item && item.schedule.service_item.description || '-'"
                                :provider="getProvider(item)"
                                :address="getAddress(item)"
                            ></user-appointment>
                        </v-flex>
                        <v-flex xs12>
                            <item-counter
                                :length="appointments.length"
                                :total="totalItems"
                            ></item-counter>
                            <next-page-btn
                                :loading="consulting"
                                v-if="nextPageUrl"
                                :nextFn="loadNextPage"
                            ></next-page-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import {ApiUtils} from '@/utils/ApiUtils'
import WMainTitle from '@/components/common/WMainTitle'
import {queryFilterBuilder} from '@/utils/Shared'

export default {
    components: {
        WMainTitle,
        UserAppointment: () =>
            import('@/components/panel-data/UserAppointmentSingle.vue'),
        NextPageBtn: () => import('@/components/common/NextPageBtn'),
        ItemCounter: () => import('@/components/common/ItemCounter')
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: 'Agenda',
                    disabled: true,
                    to: ''
                }
            ],
            appointments: [],
            nextPageUrl: null,
            totalItems: null,
            loading: false,
            consulting: false,
            state: null,
            states: [
                {value: 1, text: 'Citas Confirmadas'},
                {value: 0, text: 'Citas por Confirmar'}
            ]
        }
    },
    async mounted() {
        const vm = this
        vm.loading = true
        vm.appointments = await vm.ask('appointments', {per_page: 10})
        vm.loading = false
    },
    methods: {
        async clear() {
            const vm = this
            vm.appointments = await vm.ask('appointments', {per_page: 10})
        },
        async ask(url, params = {}) {
            const vm = this
            const response = await ApiUtils.makeGet(url, params)
            const json = await response.json()
            if (response.ok) {
                const d = json.result.appointments
                vm.totalItems = d.total
                vm.nextPageUrl = d.next_page_url
                return d.data
            }
            return []
        },
        async applyFilters() {
            const vm = this
            const filters = {confirmed: vm.state}
            const query = queryFilterBuilder(filters)
            vm.consulting = true
            let url = 'appointments'
            if (query.ok) url += `?${query.query}`
            vm.appointments = await vm.ask(url)
            vm.consulting = false
        },
        async loadNextPage() {
            const vm = this
            if (!vm.nextPageUrl) return
            vm.consulting = true
            const newAppointments = await vm.ask(vm.nextPageUrl.split('/v1/')[1])
            vm.appointments = [...vm.appointments, ...newAppointments]
            vm.consulting = false
        },
        getProvider(item) {
            const vm = this
            return item.schedule.service_provider.institution && item.schedule.service_provider.institution.name || 'n/d'
        },
        getAddress(item) {
            const vm = this
            return item.schedule.branch_office && item.schedule.branch_office.address || 'n/d'
        }
    }
}
</script>